export default __webpack_public_path__ + "static/history-icon-8a15b360cb1265e909f779416354f7db.svg";